import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPatientList } from '../../../store/groups/actions';
import { customBrowserFormat, formatBrowserTimeZone } from '../../../components/common/DateTimeFormatter';
import { GetAllLocation } from '../../../api/groupsapi';
import { formatPhoneNumberAsYouType } from "../../../helpers/formatterHelper";

export function PatientDetailModal({ show, onClose, handlePatientList, model }) {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ sort: 0, searchby: '', locationId: 0, groupId: 0 });
    const { groupId } = useParams();
    const { patientList } = useSelector(state => state.grouplists);
    const [selectedPatientList, setSelectedPatientList] = useState([]);

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        const updatedFilter = { ...filter, groupId: parseInt((groupId != undefined && groupId != null && groupId != '' ? groupId : 0)) };
        dispatch(getPatientList(updatedFilter));
    }, [dispatch, filter, groupId, show]);

    useEffect(() => {
        if (model != undefined && model !== null) {
            setSelectedPatientList(model);
        }
    }, [model, show]);


    useEffect(() => {
        GetAllLocation().then((response) => {
            if (response.data.success) setLocations(response.data.data);
        });
    }, []);

    const handlePatientToggle = (e, patient) => {
        const checked = e.target.checked;
        const updatedOrganization = checked
            ? [...selectedPatientList, patient]
            : selectedPatientList.filter(item => item.id !== patient.id);
        setSelectedPatientList(updatedOrganization);
    }

    const handleSave = () => {
        if (selectedPatientList && selectedPatientList.length > 0) {
            handlePatientList(selectedPatientList)
            setSelectedPatientList([]);
            setFilter({ sort: 0, searchby: '', locationId: 0, groupId: 0 }); // Reset the filter
            onClose();
        }
    };
    const handleOnClose = () => {
        setFilter({ sort: 0, searchby: '', locationId: 0, groupId: 0 }); // Reset the filter
        onClose(); // Close the modal           
    };

    const getMaxAppointmentDate = (appointments) => {
        if (!appointments || appointments.length === 0) {
            return null;
        }
        // Extract the scheduledDateTime from each appointment
        const appointmentDates = appointments.map((appointment) =>
            new Date(appointment.appointmentDateTime)
        );
        // Find the maximum date
        const maxDate = new Date(Math.max.apply(null, appointmentDates));

        return maxDate;
    };

    const handleSelectChange = (e) => {
       
        const selectedCompanyId = parseInt(e.target.value);
        setFilter({ ...filter, locationId: selectedCompanyId });

    };


    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            handleOnClose();
        }
    }, [handleOnClose]);

    useEffect(() => {
        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, handleKeyDown]);

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay patient-group-wrapper">
            <div className="admin-modal group-modal">

                <div className="admin-page-title-wrap">
                    <h1 className="admin-page-heading">Add to Group</h1>
                </div>
                <button className="admin-modal-close modal-close" onClick={handleOnClose}>
                    <span className="material-symbols-rounded">close</span>
                </button>

                <div className="pageContainer">
                    <div className="pt patient-details-table">
                        <div className="admin-bottom-bar filter-bar">
                            <div className="admin-bottom-bar-left position-relative w-100">
                                <input className="admin-default-search quoteradius w-100"
                                    type="text"
                                    placeholder="Search by Name or Phone Number"
                                    value={filter.searchby}
                                    onChange={(e) => setFilter({ ...filter, searchby: e.target.value })}
                                />
                            </div>

                        </div>

                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th className="admin-table-name-cell"></th>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Last Name</th>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 2 ? 3 : 2 })} className={filter.sort == 2 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 3 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>First Name</th>
                                    <th onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable')}>Phone Number</th>
                                    <th className="admin-table-name-cell">

                                        <select className="admin-default-select" onChange={handleSelectChange} value={filter.locationId} >
                                            <option value="0">All</option>
                                            {locations.map((option, index) => (
                                                <option key={index} value={option?.id}>
                                                    {option?.name}
                                                </option>
                                            ))}
                                        </select>

                                    </th>
                                    <th className="admin-table-name-cell">Last Appointment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {patientList && patientList.map((item, index) => {
                                    const maxAppointmentDate = getMaxAppointmentDate(item.appointments);
                                    const locationNames = item.appointments?.map(appointment => appointment?.location?.name);

                                    return (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    className="admin-inline-checkbox detail-list-checkbox"
                                                    type="checkbox"
                                                    checked={selectedPatientList && selectedPatientList.some(x => x.id === item.id)}
                                                    onChange={(e) => {
                                                        handlePatientToggle(e, item);
                                                    }}
                                                />
                                            </td>

                                            <td className="admin-table-name-cell">
                                                <span className="bold space-nowrap">{item?.lastName}</span><br />
                                            </td>
                                            <td className="admin-table-name-cell">
                                                <span className="bold space-nowrap">{item?.firstName}</span>
                                            </td>
                                            <td className="admin-table-name-cell">
                                                <span className="bold space-nowrap">
                                                    {formatPhoneNumberAsYouType(item?.phoneNumber?.number)}
                                                </span>
                                            </td>
                                            <td className="admin-table-name-cell location-name-td">
                                            {/*{locationNames.length > 0 ? locationNames.join(', ') : ''}*/}                                               
                                                {Array.from(new Set(locationNames)).length > 0
                                                    ? Array.from(new Set(locationNames)).join(', ') : ''}                                              
                                            </td>
                                            <td className="admin-table-name-cell">
                                                <span className="admin-round-swatch-container">
                                                    {maxAppointmentDate ? <div>
                                                        <div>{customBrowserFormat(maxAppointmentDate)}</div>
                                                        <div>@ {formatBrowserTimeZone(maxAppointmentDate)}</div>
                                                    </div> : 'No appointments'}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <button className="admin-modal-button power primary-button" onClick={handleSave}>Add to Group</button> {/*onClick={handleSave}*/}
                </div>
            </div>
        </div>
    );
}

PatientDetailModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handlePatientList: PropTypes.func.isRequired,
    model: PropTypes.array
};